import React from 'react'
import { useContext } from 'react'
import { LocaleContext } from '../routes'
import { LabelExtra } from '../styles/elements'
import Image from '../styles/image'
import {
  Planet, PlanetIcon, PlanetDescription, PlanetTitle, PlanetState, PlanetScore,
} from '../styles/planet'
import Percentage from '../views/common/Percentage'
import { getPersianNumber } from '../utils/number'

export default ({
  isPassed, isCurrent, isShown, finishedRides,
  type, className, minRidesForNextPlanet, nextPlanetType, isLastPlanet,
  minNumOfRides,
}) => {

  const locale = useContext(LocaleContext)
  const percentage = isPassed || isLastPlanet ?
    100
    :
    Math.round(finishedRides * 100 / minRidesForNextPlanet)

  const CurrentNumber = props => <LabelExtra {...props} color="blue" fontSize="14px" lh="20px" />
  const MinNumber = props => <LabelExtra {...props} color="black" fontSize="10px" lh="20px" />

  return (
    <Planet isCurrent={isCurrent} isShown={isShown}>
      <PlanetIcon isShown={isCurrent} className={className}>
        <span />
        <Image src={require(`../planets/${type.toLowerCase()}.png`)} width="24px" />
      </PlanetIcon>
      <PlanetDescription>
        <PlanetTitle>
          {locale[type]}
        </PlanetTitle>
        <PlanetState>
          {isPassed || isCurrent ?
            isCurrent ?
              isLastPlanet ?
                <>
                  {locale.YOU_REACHED_GALAXY}.
                </>
                :
                <>
                  <CurrentNumber>{getPersianNumber(minRidesForNextPlanet - finishedRides)}</CurrentNumber>
                  {locale.TRAVELS_TO_REACH} {locale[nextPlanetType]}
                </>
              :
              <>
                {locale.PASSED_SUCCESSFULLY}.
              </>
            :
            <>
              {locale.HAVENT_REACHED_YET(type)}
            </>
          }
        </PlanetState>
      </PlanetDescription>
      <PlanetScore>
        <Percentage
          percent={percentage || 0}
          isPassed={isPassed || isCurrent}
          minNumOfRides={minNumOfRides}
          width="40"
        />
      </PlanetScore>
    </Planet>
  )
}